module.exports = __webpack_public_path__ + "img/corporate-competition-2024-schedule-men-group-semi-finals-2.96ad2677.jpg";